import moment from "moment";

export function getChartXAxisInterval(dataLength, exportMode) {
  if (!dataLength) return 0;

  if (!exportMode) {
    return Math.max(0, Math.floor(dataLength / 6));
  }

  if (dataLength <= 6) return 0;
  if (dataLength <= 12) return 1;
  if (dataLength <= 24) return 2;
  if (dataLength <= 40) return Math.max(2, Math.floor(dataLength / 8));
  return Math.max(3, Math.floor(dataLength / 6));
}

export function getChartXAxisTickFormatter(date, dataLength, exportMode) {
  if (!date) return "";

  if (exportMode && dataLength > 20) {
    return moment(date).format("YYYY");
  }

  if (exportMode && dataLength > 12) {
    return moment(date).format("MMM YY");
  }

  return moment(date).format("MMM YYYY");
}

export function getChartXAxisTickProps(dataLength, exportMode) {
  if (!exportMode) {
    return { dy: 10 };
  }

  if (dataLength > 12) {
    return {
      dy: 4,
      fontSize: 11,
      angle: -35,
      textAnchor: "end",
    };
  }

  return {
    dy: 10,
    fontSize: 11,
  };
}

export function getExportChartDimensions() {
  return {
    width: 520,
    height: 320,
  };
}
